import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "list__item" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "list__item__actions" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "save", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "edit", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "cancel", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "delete_forever", -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("form", {
      class: "list__item__form",
      onSubmit: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submitEditDomainHandler && _ctx.submitEditDomainHandler(...args)))
    }, [
      (_ctx.edit)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            class: "input",
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.domainComponent.name) = $event)),
            style: {"width":"60%"},
            placeholder: "teleperformance.com"
          }, null, 512)), [
            [_vModelText, _ctx.domainComponent.name]
          ])
        : (_openBlock(), _createElementBlock("p", {
            key: 1,
            href: _ctx.domainComponent.name,
            class: "list__item__link"
          }, _toDisplayString(_ctx.domainComponent.name), 9, _hoisted_2)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.edit)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass(["button is-link is-small form-buttons mr-2", _ctx.loadingAction ? 'is-loading' : '']),
              type: "submit",
              "data-test": "button-save"
            }, _hoisted_5, 2))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: _normalizeClass(["button is-success is-small form-buttons mr-2", _ctx.loadingAction ? 'is-loading' : '']),
              type: "button",
              "data-test": "button-edit",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.edit = true))
            }, _hoisted_7, 2)),
        (_ctx.edit)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              class: _normalizeClass(["button is-danger is-small form-buttons", _ctx.loadingAction ? 'is-loading' : '']),
              type: "button",
              "data-test": "button-cancel",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancelEditHandler(false)))
            }, _hoisted_9, 2))
          : (_openBlock(), _createElementBlock("button", {
              key: 3,
              class: _normalizeClass(["button is-danger is-small form-buttons", _ctx.loadingAction ? 'is-loading' : '']),
              type: "button",
              "data-test": "button-delete",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.deleteDomainHandler && _ctx.deleteDomainHandler(...args)))
            }, _hoisted_11, 2))
      ])
    ], 32)
  ]))
}